import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'
import { pxToRem } from '#commerce/utils/pxToRem'

export default {
  brandClasses: {
    content: 'space-y-2 md:(p-6 -m-6) lg:space-y-4',
    contentContainer: 'relative w-full flex container md:(pointer-events-none py-12)',
    contentCtaContainer: 'gap-4 not-first:pt-4 lg:gap-6 <md:w-full',
    contentCtaContainerInner: 'flex gap-4 wrap lg:gap-6'
  },
  brandStyles: {
    containerFullHeight: (height) => ({
      h: {
        sm: `calc(100svh - ${pxToRem(height)})`
      }
    })
  }
} satisfies RecursivePartial<CMSConfig['hero']>
